import './index.scss';
import { useCallback, useContext } from 'react';
import { AppLabel, FlexRow } from 'src/style';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { IResultList, ResultProps } from '../types';
import { AiFillDelete } from 'react-icons/ai';

export const InputTable = ({result, handleDelete}: ResultProps) => {
    const { info } = useContext(AppInfoContext);

    const renderInput = useCallback((resultList) => resultList?.map((result: IResultList, id: number) => (
        <FlexRow className='result-items' key={result.sn} justifyContent='space-between' isMaxWidth>
            <AppLabel className='input-sn' fontWeight='500' color='#374957' align='center'>{result.sn}</AppLabel>
            <AppLabel className='subject' fontWeight='500' color='#374957' align='center'>{result?.subject}</AppLabel>
            <AppLabel className='score' fontWeight='500' color='#374957' align='center'>{result?.score}</AppLabel>
            <AppLabel className='delete-btn' fontWeight='500' color='#374957' align='center' cursor='default'><AiFillDelete onClick={() => handleDelete(result.sn, resultList)} size={20} /></AppLabel>
        </FlexRow>
    )), [])

    return (
        <div className="input-table">
            <FlexRow className='title-items' justifyContent='space-between' isMaxWidth>
                <AppLabel className='input-sn' fontWeight='600' color='#712126' align='center'>SN</AppLabel>
                <AppLabel className='subject' fontWeight='600' color='#712126' align='center'>Subject</AppLabel>
                <AppLabel className='score' fontWeight='600' color='#712126' align='center'>Score</AppLabel>
                <AppLabel className='delete-btn' fontWeight='600' color='#712126' align='center'></AppLabel>
            </FlexRow>
            {renderInput(result)}
        </div>
    )
}
